import {type RefObject, useRef} from "react";

import {useIsomorphicLayoutEffect} from "./use_isomorphic_layout_effect";

/**
 * Ref that always holds the value from the last committed render. Lets stable callbacks and document listeners
 * read fresh props without re-subscribing.
 */
export const useLatestRef = <T>(value: T): RefObject<T> => {
    const ref = useRef(value);

    useIsomorphicLayoutEffect(() => {
        ref.current = value;
    });

    return ref;
};
import {type RefObject, useRef} from "react";

import {useIsomorphicLayoutEffect} from "./use_isomorphic_layout_effect";

/**
 * Ref that always holds the value from the last committed render. Lets stable callbacks and document listeners
 * read fresh props without re-subscribing.
 */
export const useLatestRef = <T>(value: T): RefObject<T> => {
    const ref = useRef(value);

    useIsomorphicLayoutEffect(() => {
        ref.current = value;
    });

    return ref;
};
